export const useResourceManager = () => {
    return (window as any).Resources
}